module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/address/postcode.js
// module id = 1353
// module chunks = 0